import React, { useState, useContext, useEffect } from "react";
import { TranslatorContext } from "../../../context/Translator";
import Modal from 'react-bootstrap/Modal';
import { AnchorComponent, ButtonComponent } from "../../elements";
import { Pagination, Table } from 'react-bootstrap';

export default function ProductsListComponent({ products, onDeleteProduct, pagination, onPageChange }) {
    const { t } = useContext(TranslatorContext);
    const [deleteModal, setDeleteModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const handleDeleteClick = (product) => {
        setSelectedProduct(product);
        setDeleteModal(true);
    };

    const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

    const hasPermission = (perm) => {
        return permissions.includes(perm);
    };

    const confirmDelete = () => {
        if (selectedProduct && onDeleteProduct) {
            onDeleteProduct(selectedProduct.id, selectedProduct.name);
        }
        setDeleteModal(false);
        setSelectedProduct(null);
    };

    const renderPaginationItems = () => {
        const items = [];
        const currentPage = pagination?.current_page || 1;
        const lastPage = pagination?.last_page || 1;

        // Previous button
        items.push(
            <Pagination.Prev
                key="prev"
                onClick={() => onPageChange(currentPage - 1)}
                disabled={currentPage === 1}
            />
        );

        // Page numbers
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(lastPage, currentPage + 2);

        if (startPage > 1) {
            items.push(
                <Pagination.Item key={1} onClick={() => onPageChange(1)}>
                    1
                </Pagination.Item>
            );
            if (startPage > 2) {
                items.push(<Pagination.Ellipsis key="ellipsis1" disabled />);
            }
        }

        for (let page = startPage; page <= endPage; page++) {
            items.push(
                <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => onPageChange(page)}
                >
                    {page}
                </Pagination.Item>
            );
        }

        if (endPage < lastPage) {
            if (endPage < lastPage - 1) {
                items.push(<Pagination.Ellipsis key="ellipsis2" disabled />);
            }
            items.push(
                <Pagination.Item key={lastPage} onClick={() => onPageChange(lastPage)}>
                    {lastPage}
                </Pagination.Item>
            );
        }

        // Next button
        items.push(
            <Pagination.Next
                key="next"
                onClick={() => onPageChange(currentPage + 1)}
                disabled={currentPage === lastPage}
            />
        );

        return items;
    };

    if (!products || products.length === 0) {
        return (
            <div className="text-center py-5">
                <i className="material-icons" style={{ fontSize: '48px', color: '#ccc' }}>inventory</i>
                <p className="mt-2 text-muted">{t('No products found')}</p>
            </div>
        );
    }

    return (
        <>
            <div className="table-responsive-wrapper">
                <Table responsive hover className="table mb-0">
                    <thead>
                        <tr>
                            <th>
                                <div className="mc-table-check">
                                    <p>#</p>
                                </div>
                            </th>
                            <th>{t('image')}</th>
                            <th>{t('product name')}</th>
                            <th>{t('category')}</th>
                            <th>{t('online')}</th>
                            <th>{t('actions')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {products.map((item, index) => (
                            <tr key={item.id}>
                                <td>
                                    <div className="mc-table-check">
                                        <p>{((pagination?.current_page - 1) * pagination?.per_page) + index + 1}</p>
                                    </div>
                                </td>

                                <td>
                                    {item.card_img || item.detail_img ? (
                                        <img
                                            src={process.env.REACT_APP_IMG_URL + (item.card_img || item.detail_img)}
                                            alt={item.name}
                                            style={{ width: 50, height: 50, objectFit: 'cover', borderRadius: '8px' }}
                                        />
                                    ) : (
                                        <div style={{ width: 50, height: 50, background: '#f0f0f0', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <i className="material-icons" style={{ color: '#ccc' }}>image</i>
                                        </div>
                                    )}
                                </td>

                                <td> <strong>{item.vendor?.company_name || '-'}</strong> - {item.name}</td>
                              

                                <td>{item.category?.name || '-'}</td>

                                <td>
                                    {item.is_online ? (
                                        <span className="badge bg-success">{t('Yes')}</span>
                                    ) : (
                                        <span className="badge bg-danger">{t('No')}</span>
                                    )}
                                </td>

                                <td>
                                    <div className="mc-table-action">
                                        {hasPermission("Products view") && (
                                            <AnchorComponent
                                                to={`/product-show/${item.slug}`}
                                                title="View"
                                                className="material-icons view"
                                            >
                                                visibility
                                            </AnchorComponent>
                                        )}
                                        {hasPermission("Products edit") && (
                                            <AnchorComponent
                                                to={`/product-edit/${item.slug}`}
                                                title="Edit"
                                                className="material-icons edit"
                                            >
                                                edit
                                            </AnchorComponent>
                                        )}
                                        {/* <ButtonComponent
                                            type="button"
                                            className="material-icons delete"
                                            onClick={() => handleDeleteClick(item)}
                                        >
                                            delete
                                        </ButtonComponent> */}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>

                {/* Pagination */}
                {pagination && pagination.last_page > 1 && (
                    <div className="d-flex justify-content-between align-items-center mt-3 p-3">
                        <div className="text-muted">
                            {t('Showing')} {((pagination.current_page - 1) * pagination.per_page) + 1}
                            {t('to')} {Math.min(pagination.current_page * pagination.per_page, pagination.total)}
                            {t('of')} {pagination.total} {t('entries')}
                        </div>
                        <Pagination>
                            {renderPaginationItems()}
                        </Pagination>
                    </div>
                )}
            </div>

            {/* Delete Confirmation Modal */}
            <Modal show={deleteModal} onHide={() => setDeleteModal(false)} centered>
                <div className="mc-alert-modal p-4 text-center">
                    <i className="material-icons" style={{ fontSize: '50px', color: 'red' }}>new_releases</i>
                    <h3 className="mt-3">{t("Are you sure?")}</h3>
                    <p>{t("Want to delete this product?")}</p>
                    {selectedProduct && (
                        <p className="fw-bold text-danger">{selectedProduct.name}</p>
                    )}
                    <div className="d-flex justify-content-center gap-2 mt-3">
                        <ButtonComponent
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setDeleteModal(false)}
                        >
                            {t('close')}
                        </ButtonComponent>
                        <ButtonComponent
                            type="button"
                            className="btn btn-danger"
                            onClick={confirmDelete}
                        >
                            {t('delete')}
                        </ButtonComponent>
                    </div>
                </div>
            </Modal>
        </>
    );
}